module.exports = __webpack_public_path__ + "static/media/madame-destiny.040088b5.gif";